import { render } from "./ConfirmRegistration.vue?vue&type=template&id=0294b1ca"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=js"

import "./ConfirmRegistration.vue?vue&type=style&index=0&id=0294b1ca&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__